import { render, staticRenderFns } from "./Provisioning-Send-PSI.vue?vue&type=template&id=994dc710&"
import script from "./Provisioning-Send-PSI.vue?vue&type=script&lang=js&"
export * from "./Provisioning-Send-PSI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports